import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledConstrainedLayout = styled.div`
  position: relative;
  padding: ${tvar('space.single')} ${tvar('space.double')};

  &:first-child {
    &:before {
      position: absolute;
      height: 2.4rem;
      width: 60vw;
      right: 0;
      top: 0;
      background: ${tvar('colors.brand.secondary')};
    }
    &:after {
      position: absolute;
      height: 4rem;
      width: 4rem;
      top: 0.4rem;
      right: calc(60vw - 1rem);
      transform: rotate(45deg);
      z-index: 1;
      background: ${tvar('colors.fill.primary')};
    }
  }

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    padding: ${tvar('space.x4')} ${tvar('space.x4')} ${tvar('space.x6')};
    &:before,
    &:after {
      content: '';
    }
  }
`;

export const StyledConstrainedContent = styled.main`
  max-width: ${tvar('measures.content.constrained')};
  margin: 0 auto;
`;
